<a
  data-at-main-device-tile
  class="tile gap-[8px]"
  draggable="true"
  [routerLink]="['/installations', installationId]"
  [queryParams]="{ gatewaySerial: device.gatewaySerial }"
>
  <img data-at-img [src]="getImageUri()" class="device-img" />

  <div class="flex flex-col">
    <div data-at-marketing-name class="device-name">
      <span class="installation-title">{{
        isStandaloneGateway
          ? ('+INSTALLATIONS.INSTALLATION.BASIC_CONTROL.COMMISSIONING_MANAGER.TITLE' | translate)
          : device.marketingName
      }}</span>
      <img *ngIf="brandLogo" class="logo-brand ml-2" src="{{ brandLogo }}" />
    </div>
    <small data-at-boiler-serial-multigateway>
      {{ isStandaloneGateway ? device.gatewaySerial : device.serial }}</small
    >
  </div>
  <div
    class="icon-status"
    *ngIf="installationsStore.selectAggregatedStatus(device.gatewaySerial) | async as gatewayStatus"
  >
    <mat-icon
      *ngIf="gatewayStatus === aggregatedStatus.Error"
      [matTooltip]="getTooltip()"
      class="error-mode flex flex-row justify-center items-stretch flex-[20px] max-w-[20px]"
      >error</mat-icon
    >
    <mat-icon
      *ngIf="gatewayStatus === aggregatedStatus.Offline"
      [matTooltip]="getTooltip()"
      class="offline-mode flex flex-row justify-center items-stretch flex-[20px] max-w-[20px]"
      >wifi_off</mat-icon
    >
    <mat-icon
      *ngIf="gatewayStatus === aggregatedStatus.Maintenance"
      [matTooltip]="getTooltip()"
      class="maintenance-mode flex flex-row justify-center items-stretch flex-[20px] max-w-[20px]"
      >build</mat-icon
    >
    <mat-icon
      *ngIf="gatewayStatus === aggregatedStatus.RemoteDiagnosticSession"
      [matTooltip]="getTooltip()"
      class="diagnostic-mode flex flex-row justify-center items-stretch flex-[20px] max-w-[20px]"
      >timeline</mat-icon
    >
  </div>
</a>
